import { MccsRoles } from '@/@types/generated/models/MccsRoles'
import { register } from './enum'

const MccsRolesLabels: Record<MccsRoles, string> = {
  [MccsRoles.SYSTEM]: 'System',
  [MccsRoles.ADMINISTRATOR]: 'Administrator',
  [MccsRoles.CHIEF_INVESTIGATOR]: 'Chief Investigator',
  [MccsRoles.INVESTIGATOR]: 'Investigator',
  [MccsRoles.LEGAL]: 'Legal',
  [MccsRoles.CREDENTIALING]: 'Credentialing',
  [MccsRoles.CREDENTIALING_ADMIN]: 'Credentialing Admin',
  [MccsRoles.FINANCE]: 'Finance',
  [MccsRoles.INSURANCE_PROVIDER]: 'Insurance Provider',
  [MccsRoles.BROKER]: 'Broker',
  [MccsRoles.MOTOR_CARRIER_OWNER]: 'Motor Carrier Owner',
  [MccsRoles.MOTOR_CARRIER_USER]: 'Motor Carrier User',
  [MccsRoles.AUTONOMOUS_VEHICLE_OWNER]: 'Automated Vehicle Owner',
  [MccsRoles.AUTONOMOUS_VEHICLE_USER]: 'Automated Vehicle User',
  [MccsRoles.LICENSING_AGENCY_OWNER]: 'Licensing Agency Owner',
  [MccsRoles.LICENSING_AGENCY_USER]: 'Licensing Agency User',
}

register<MccsRoles>(MccsRoles, (v) => {
  if (!v) return '\u2014'
  return MccsRolesLabels[v]
})
